import { render, staticRenderFns } from "./UpdateASingleUser.vue?vue&type=template&id=1329c0a7"
import script from "./UpdateASingleUser.vue?vue&type=script&lang=js"
export * from "./UpdateASingleUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports